export { WorldMap } from './WorldMap';
